import { CommonErrorBoundary } from '#app/components/error-boundary.js'
import { Outlet } from '@remix-run/react'

export default function Index() {
	return (
		<div className="flex grow p-(--gutter)">
			<div className="prose sm:prose-sm prose-zinc dark:prose-invert prose-headings:font-semibold mx-auto flex w-full flex-col pb-8 md:pb-12">
				<Outlet />
			</div>
		</div>
	)
}

export const ErrorBoundary = CommonErrorBoundary
